export function setUrna(valor, self) {
  const value = event.target.value;

  if (self.urnaNumber.length < self.MaxNumberInformation) {
    if (valor === '1') {
      self.urnaNumber = self.urnaNumber + valor;
    } else if (valor === '2') {
      self.urnaNumber = self.urnaNumber + valor;
    } else if (valor === '3') {
      self.urnaNumber = self.urnaNumber + valor;
    } else if (valor === '4') {
      self.urnaNumber = self.urnaNumber + valor;
    } else if (valor === '5') {
      self.urnaNumber = self.urnaNumber + valor;
    } else if (valor === '6') {
      self.urnaNumber = self.urnaNumber + valor;
    } else if (valor === '7') {
      self.urnaNumber = self.urnaNumber + valor;
    } else if (valor === '8') {
      self.urnaNumber = self.urnaNumber + valor;
    } else if (valor === '9') {
      self.urnaNumber = self.urnaNumber + valor;
    } else if (valor === '0') {
      self.urnaNumber = self.urnaNumber + valor;
    } else if (valor === 'Corrige') {
      self.picture = 'Empty.png';
      self.showImage = false;
      self.urnaNumber = '';
      self.number = '';
      self.nickname = '';
      self.isAllowedToContinue = false;
      self.disableKey = false;
    } else if (valor === 'BRANCO') {
      self.urnaNumber = 'BRANCO';
    } else if (valor === 'Confirma') {
      self.urnaNumber = 'enter';
    }
  } else if (valor === 'Corrige') {
    self.picture = 'Empty.png';
    self.showImage = false;
    self.urnaNumber = '';
    self.number = '';
    self.nickname = '';
    self.isAllowedToContinue = false;
    self.disableKey = false;
  } else if (valor === 'BRANCO') {
    self.urnaNumber = 'BRANCO';
  }

  if (String(value).length < self.MaxNumberInformation) {
    if (event.key === '1') {
      self.urnaNumber = self.urnaNumber + event.key;
    } else if (event.key === '2') {
      self.urnaNumber = self.urnaNumber + event.key;
    } else if (event.key === '3') {
      self.urnaNumber = self.urnaNumber + event.key;
    } else if (event.key === '4') {
      self.urnaNumber = self.urnaNumber + event.key;
    } else if (event.key === '5') {
      self.urnaNumber = self.urnaNumber + event.key;
    } else if (event.key === '6') {
      self.urnaNumber = self.urnaNumber + event.key;
    } else if (event.key === '7') {
      self.urnaNumber = self.urnaNumber + event.key;
    } else if (event.key === '8') {
      self.urnaNumber = self.urnaNumber + event.key;
    } else if (event.key === '9') {
      self.urnaNumber = self.urnaNumber + event.key;
    } else if (event.key === '0') {
      self.urnaNumber = self.urnaNumber + event.key;
    } else if (event.key === '-') {
      self.urnaNumber = '';
    } else if (event.key === '*') {
      self.urnaNumber = 'BRANCO';
    } else if (event.keyCode === 13) {
      self.urnaNumber = 'enter';
    }
  } else if (event.key === '-') {
    self.urnaNumber = '';
    if (self.urnaNumber === 'BRANCO') {
      self.urnaNumber = '';
    }
  } else if (event.key === '*') {
    self.urnaNumber = 'BRANCO';
  }
}
export default { setUrna };
